import React from "react";
import './Event.css';

import { extractDateParts } from "../../utils";

import { Link } from "react-router-dom";



const Event = ({ event }) => {

    const { weekday, day, shortMonth } = extractDateParts(event.details.date); // Extracting formatted date parts using utility function

    return (

        <div className="event-item">

            <img src={event.image} alt={event.title} /> {/* Event Image */}

            <div className="content">

                <div className="date">{weekday} <br></br><span>{day}</span> {shortMonth}</div> {/* Event Date */}

                <div className="text">

                    <h5>{event.details.time}</h5> {/* Event Time */}

                    {/* Link to the individual Event page */}
                    <Link
                        to={{
                            pathname: '/Events/' + event.title,  // Navigate to the specific Event page
                        }}
                        location = {{event}}  // Passing Event details to the linked page
                        className="main-heading"
                        state= {event}> 
                        {event.title} {/* Event Title */}
                    </Link>

                    <h3>{event.details.venue}</h3> {/* Event Location */}

                </div>


            </div>

        </div>
    );
};

export default Event;